export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";